
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PagemasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface Pagemaster {

    id?: number;
    name: string;
    moduleId:any;
      
    parameters?: PagemasterParameter[];
    links?: any;
  }
  

  export abstract class PagemasterData {

    abstract list(): Observable<Pagemaster[]>;
    abstract create(url: string,data: Pagemaster): Observable<any>;
    abstract update(url: string,data: Pagemaster): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract getPageListByModuleId(url: string): Observable<Pagemaster[]>;

  }
